var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneProtectorCover1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "270px",
    viewBox: "0 0 360 270",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.961959308%",
    y1: "-16.143681%",
    x2: "99.9486869%",
    y2: "102.925079%",
    id: "linearGradient-0_1x-mhijb-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9070FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDB3FF",
    offset: "35.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3CEFF",
    offset: "66.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4FF",
    offset: "88.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "21.5010122%",
    y1: "8.33120878%",
    x2: "86.5732185%",
    y2: "86.0775892%",
    id: "linearGradient-0_1x-mhijb-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5313AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4EC1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-33.4249651%",
    y1: "-50.7677972%",
    x2: "97.7081081%",
    y2: "126.597008%",
    id: "linearGradient-0_1x-mhijb-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5313AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4EC1",
    offset: "46.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A989D6",
    offset: "81.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C4EA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-11.4217216%",
    y1: "-34.1661573%",
    x2: "86.1063309%",
    y2: "106.920797%",
    id: "linearGradient-0_1x-mhijb-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5313AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4EC1",
    offset: "46.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A989D6",
    offset: "81.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C4EA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-102.441578%",
    y1: "-211.408838%",
    x2: "82.3200243%",
    y2: "91.5235667%",
    id: "linearGradient-0_1x-mhijb-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5313AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4EC1",
    offset: "46.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A989D6",
    offset: "81.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C4EA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "42.9755672%",
    y1: "30.3843402%",
    x2: "85.5174715%",
    y2: "125.76794%",
    id: "linearGradient-0_1x-mhijb-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5313AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4EC1",
    offset: "46.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A989D6",
    offset: "81.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C4EA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.2034809%",
    y1: "-49.6204944%",
    x2: "114.179262%",
    y2: "148.135192%",
    id: "linearGradient-0_1x-mhijb-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5313AD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E4EC1",
    offset: "46.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A989D6",
    offset: "81.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4C4EA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "landing_03",
    transform: "translate(-1295.000000, -3010.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portfolio_01",
    transform: "translate(-150.000000, 3000.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy-4",
    fill: "#DCDCDE",
    x: 1445,
    y: 10,
    width: 360,
    height: 270
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EBEBED",
    cx: 1625,
    cy: 145,
    r: 70
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(1600.000000, 120.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38,50 L12,50 C5.4,50 0,44.6 0,38 L0,12 C0,5.4 5.4,0 12,0 L38,0 C44.6,0 50,5.4 50,12 L50,38 C50,44.6 44.6,50 38,50 Z",
    id: "Path",
    fill: "#5313AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6,44.8 C25.2,45 24.8,45 24.5,44.8 C20.2,42.8 16.4,39.6 13.5,35.7 C10.2,31.1 8.4,25.9 8.5,20.4 C8.5,18.1 8.6,15.8 8.6,13.6 C8.6,13 9,12.5 9.5,12.3 C14.5,9.9 19.6,7.5 24.5,5.3 C24.9,5.1 25.3,5.1 25.6,5.3 C30.5,7.6 35.5,9.9 40.6,12.3 C41.1,12.5 41.5,13 41.5,13.6 C41.6,15.9 41.6,18.2 41.6,20.4 C41.7,25.9 39.9,31.1 36.6,35.7 C33.7,39.6 29.9,42.8 25.6,44.8 L25.6,44.8 Z",
    id: "Path_673_00000006672792976776265060000008539987110919633552_",
    fill: "url(#linearGradient-0_1x-mhijb-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2,40.2 C25.1,40.3 24.9,40.3 24.8,40.2 C21.7,38.6 19,36.2 16.9,33.2 C14.2,29.4 12.7,24.9 12.7,20.3 C12.7,18.7 12.7,17.1 12.8,15.5 C12.8,15.3 12.9,15.1 13.1,15.1 C17,13.3 20.9,11.5 24.8,9.7 C24.9,9.6 25.1,9.6 25.2,9.7 C29.1,11.4 33,13.3 36.9,15.1 C37.1,15.2 37.2,15.3 37.2,15.5 C37.2,17.1 37.2,18.7 37.3,20.3 C37.3,24.9 35.9,29.4 33.1,33.2 C31,36.1 28.3,38.5 25.2,40.2 L25.2,40.2 Z",
    id: "Path_674_00000078046384230671866260000010589344155411995058_",
    fill: "url(#linearGradient-0_1x-mhijb-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1,23.6 C23.1,28.3 24,33.1 25,37.8 C28.2,35.9 30.8,33.2 32.6,29.9 C29.1,27.9 25.6,25.7 22.1,23.6 Z",
    id: "Path_675_00000116201366600178030130000006314674950131125429_",
    fill: "url(#linearGradient-0_1x-mhijb-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,13.2 C26.7,12.8 25.8,12.4 25,12.1 C24,14.5 23.1,16.9 22.1,19.3 C23.1,21.7 24,24.1 25,26.5 C27.3,28.2 29.9,29.3 32.6,29.9 C33.4,28.5 34,27 34.4,25.4 C32.1,21.4 29.8,17.3 27.5,13.2 L27.5,13.2 Z",
    id: "Path_676_00000044884338650349248470000015621088241236163730_",
    fill: "url(#linearGradient-0_1x-mhijb-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4,25.5 C34.8,23.8 35.1,22.1 35.1,20.3 C35.1,19.1 35.1,17.8 35.1,16.6 C32.6,15.5 30.1,14.3 27.6,13.2 C27.5,18.2 30.1,22.9 34.4,25.5 L34.4,25.5 Z",
    id: "Path_677_00000103266953145730994300000002892451330824516495_",
    fill: "url(#linearGradient-0_1x-mhijb-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,15.5 C16.7,15.9 15.8,16.3 15,16.7 C15,17.9 15,19.2 15,20.4 C15,24.6 16.3,28.6 18.7,32.1 C20.4,34.5 22.5,36.5 25,37.9 L25,26.6 C22.5,22.8 20,19.1 17.5,15.5 L17.5,15.5 Z",
    id: "Path_678_00000163788880898170080780000010662871875261515422_",
    fill: "url(#linearGradient-0_1x-mhijb-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,26.5 L25,12.1 C22.5,13.2 20,14.4 17.5,15.5 C18.7,20 21.4,23.8 25,26.5 Z",
    id: "Path_679_00000042698811806254622310000013212230347495669169_",
    fill: "url(#linearGradient-0_1x-mhijb-7)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneProtectorCover1);
export default __webpack_public_path__ + "static/media/phoneProtectorCover1.31ef4eff7ee6d15d4966afb2b80d7bce.svg";
export { ForwardRef as ReactComponent };